export enum PinnedContentType {
  NOT_PINNED = 'NOT_PINNED',
  CURRENTLY_PINNED = 'CURRENTLY_PINNED',
  PINNED_IN_FUTURE = 'PINNED_IN_FUTURE'
}
